<script setup lang="ts">
import { computed } from "vue";
import type { ISkeletonProps } from "./VSkeleton.types";

const props = withDefaults(defineProps<ISkeletonProps>(), {
  radius: 16,
  width: "100%",
  height: "1em",
  mt: 0,
  mb: 0,
});

const containerClass = computed(() => ({
  "pl-skeleton_circle": props.circle,
}));
const containerStyle = computed(() => {
  const sizes = props.size
    ? { width: props.size, height: props.size }
    : { width: props.width, height: props.height };
  return {
    ...sizes,
    "border-radius": `${props.radius}px`,
    "margin-top": `${props.mt}px`,
    "margin-bottom": `${props.mb}px`,
  };
});
</script>

<template>
  <div class="pl-skeleton" :style="containerStyle" :class="containerClass" />
</template>

<style scoped lang="postcss">
.pl-skeleton {
  background-color: var(--pl-skeleton-background-primary);
  animation: v-skeleton-animation 2s infinite;

  &_circle {
    border-radius: 100% !important;
  }

  @keyframes v-skeleton-animation {
    0% {
      background-color: var(--pl-skeleton-background-primary);
    }

    50% {
      background-color: var(--pl-skeleton-background-secondary);
    }

    100% {
      background-color: var(--pl-skeleton-background-primary);
    }
  }
}
</style>
